module.exports = __webpack_public_path__ + "static/media/block.3412bbd2.svg";